module.exports = __webpack_public_path__ + "static/media/bedDefault.7e801147.png";